import React from "react";
import { Col } from "react-bootstrap";
import { FileField } from "../Fields/FileField";
import { requiredUpload } from "../Validation";

export const SpecialForm = () => {
    return <Col md={ 12 }>
        <FileField
            fileFieldId="translationSpecial_file"
            fileFieldName="translationSpecialFile"
            hint="Please attach any materials you have that will help us complete this project (e.g. Excel tables, images, Word documents, etc.)"
            fileFieldLabel="File Upload"
            fileFieldMultiple={ true }
            validator={ requiredUpload }
        />
    </Col>
}